import { _blast } from "@/contracts/util/config";
import { getEntries } from "@/util/core";

import { BasePoolConfig, PoolInfo } from "../types";
import { arbitrumInfo, arbitrumPools } from "./arbitrum";
import { blastInfo } from "./blast";
import { mainnetInfo, mainnetPools } from "./mainnet";

export const poolInfoByAddress: Record<`0x${string}`, PoolInfo> = {
  ...arbitrumInfo,
  ...blastInfo,
  ...mainnetInfo,
};

export const pools: BasePoolConfig[] = [
  /* mainnet */
  ...arbitrumPools,
  ...mainnetPools,
  ...getEntries(_blast).map(([, v]) => v),
];
